import React from 'react';
import type { SpacerBlock as SpacerBlockType } from '../../../types';

const SpacerBlock: React.FC<{ block: SpacerBlockType }> = ({ block }) => (
    <div style={{ height: `${Math.min(200, Math.max(0, block.height ?? 16))}px` }} />
);
export default SpacerBlock;
